import { Link, useLocation } from 'react-router-dom';
import { 
  Home, 
  Users, 
  Rss, 
  Gavel, 
  User, 
  Settings, 
  X,
  LayoutGrid
} from 'lucide-react';
import { cn } from '../../utils/formatters';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const navItems = [
  { icon: Home, label: 'Home', path: '/dashboard' },
  { icon: Rss, label: 'Feed', path: '/dashboard/feed' },
  { icon: Users, label: 'Connections', path: '/dashboard/connections' },
  { icon: Gavel, label: 'Governance', path: '/dashboard/governance' },
  { icon: User, label: 'Profile', path: '/dashboard/profile' },
  { icon: Settings, label: 'Settings', path: '/dashboard/settings' },
];

export const Sidebar = ({ isOpen, onClose }: SidebarProps) => {
  const location = useLocation();

  return (
    <>
      {/* Mobile Backdrop */}
      {isOpen && (
        <div 
          className="fixed inset-0 z-40 bg-slate-900/50 backdrop-blur-sm lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside
        className={cn(
          'fixed inset-y-0 left-0 z-50 w-64 transform bg-white border-r border-slate-200 transition-transform duration-200 ease-in-out lg:static lg:translate-x-0',
          isOpen ? 'translate-x-0' : '-translate-x-full'
        )}
      >
        <div className="flex h-16 items-center justify-between px-6 border-b border-slate-200">
          <Link to="/dashboard" className="flex items-center space-x-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-600 text-white">
              <LayoutGrid size={20} />
            </div>
            <span className="text-xl font-bold text-slate-900">Keskedo</span>
          </Link>
          <button onClick={onClose} className="lg:hidden">
            <X size={24} className="text-slate-500" />
          </button>
        </div>

        <nav className="mt-6 space-y-1 px-4">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => onClose()}
                className={cn(
                  'flex items-center space-x-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-indigo-50 text-indigo-600'
                    : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
                )}
              >
                <item.icon size={20} />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="absolute bottom-0 w-full border-t border-slate-200 p-4">
          <div className="flex items-center space-x-3 rounded-lg bg-slate-50 p-3">
            <div className="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold">
              KP
            </div>
            <div className="flex-1 overflow-hidden">
              <p className="truncate text-sm font-medium text-slate-900">Keskedo Pioneer</p>
              <p className="truncate text-xs text-slate-500">Reputation: 750</p>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};
